import { render, staticRenderFns } from "./BaseInfo.vue?vue&type=template&id=8adcadc2&scoped=true"
import script from "./BaseInfo.vue?vue&type=script&lang=js"
export * from "./BaseInfo.vue?vue&type=script&lang=js"
import style0 from "./BaseInfo.vue?vue&type=style&index=0&id=8adcadc2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adcadc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8adcadc2')) {
      api.createRecord('8adcadc2', component.options)
    } else {
      api.reload('8adcadc2', component.options)
    }
    module.hot.accept("./BaseInfo.vue?vue&type=template&id=8adcadc2&scoped=true", function () {
      api.rerender('8adcadc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customize/Front/IDL/BaseInfo.vue"
export default component.exports